module.exports = __webpack_public_path__ + "img/icon-result-note.da8fa6d2.svg";